// extracted by mini-css-extract-plugin
export var backdropBlur = "_gb-0";
export var contentCard = "_gb-5";
export var frame = "_gb-2";
export var image = "_gb-4";
export var imagePane = "_gb-3";
export var modal = "_gb-1";